import React from "react"
import PropTypes from "prop-types"
import { List, ListItem, Typography, Box } from "@mui/material"
import theme from "../../../theme/theme"
import { ReactComponent as MailIcon } from "src/v2/assets/icons/mail-icon.svg"

const CONTAINER_STYLES = {
    display: "flex",
    flexDirection: "column",
    minWidth: "339px",
    width: "auto",
    background: theme.palette.background.secondary,
    p: 0,
    gap: 1,
    height: {
        lg: "455px",
        md: "764px",
        xxxs: "220px",
    },
}

const HEADER_STYLES = {
    display: "flex",
    px: 3,
    pt: 3,
    pb: 0,
}

const LIST_STYLES = {
    display: "flex",
    flexDirection: "column",
    p: 0,
    gap: 1,
}

const NOTIFICATION_HEADER_STYLES = {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
}

const NEW_NOTIFICATION_DOT_STYLES = {
    width: 8,
    height: 8,
    borderRadius: "50%",
    background: theme.palette.ellipse.primary,
    boxShadow: "0px 0px 2px 2px #E4195380",
}

const getBackgroundColor = (index) =>
    index % 2
        ? theme.palette.background.tertiary
        : theme.palette.background.secondary

const getFontWeight = (isNew) => (isNew ? 600 : 400)

const Notification = ({ messages }) => {
    if (messages.length === 0) {
        return (
            <Box sx={CONTAINER_STYLES}>
                <Box sx={HEADER_STYLES}>
                    <Typography variant="h2" color="common.white">
                        Notificações
                    </Typography>
                </Box>

                <Box
                    sx={LIST_STYLES}
                    style={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <MailIcon style={{ color: theme.palette.icon.white70 }} />
                    <Box>
                        <Typography
                            variant="textBody"
                            color="common.gray"
                            component="span"
                            sx={{ padding: 2 }}
                        >
                            Você ainda não recebeu notificações
                        </Typography>
                    </Box>
                </Box>
            </Box>
        )
    }
    return (
        <Box sx={CONTAINER_STYLES}>
            <Box sx={HEADER_STYLES}>
                <Typography variant="h2" color="common.white">
                    Notificações
                </Typography>
            </Box>

            <List sx={LIST_STYLES}>
                {messages.map((message, index) => (
                    <ListItem
                        key={`notification-${index}`}
                        sx={{
                            backgroundColor: getBackgroundColor(index),
                            padding: 1,
                            borderRadius: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "start",
                            minWidth: "max-available",
                            py: 1,
                            px: 3,
                            gap: 1.5,
                        }}
                    >
                        <Box sx={NOTIFICATION_HEADER_STYLES}>
                            <Typography
                                variant="contraHeading"
                                color="common.gray"
                            >
                                {message.dateHour}
                            </Typography>
                            {message.isNew && (
                                <Box sx={NEW_NOTIFICATION_DOT_STYLES} />
                            )}
                        </Box>

                        <Typography
                            variant="textBody"
                            color="common.white"
                            sx={{
                                fontWeight: getFontWeight(message.isNew),
                            }}
                        >
                            {message.text}
                        </Typography>
                    </ListItem>
                ))}
            </List>
        </Box>
    )
}

Notification.propTypes = {
    messages: PropTypes.arrayOf(
        PropTypes.shape({
            dateHour: PropTypes.string.isRequired,
            text: PropTypes.string.isRequired,
            isNew: PropTypes.bool.isRequired,
        })
    ).isRequired,
}

Notification.defaultProps = {
    messages: [],
}

export default Notification
